import { useEffect } from 'react';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import growthbookFile from '@/shared/constants/growthbook';
import {
	MAINTENANCE_REFRESH_INTERVAL_MS,
	WEB_MAINTENANCE_FLAG,
} from '../constants/flag';
import { isMaintenanceBypassed } from '../lib/maintenanceBypass';

const refresh = () => {
	// skipCache: el payload fresco de la red, no el del caché de 60 s. Un fallo
	// (GrowthBook caído, sin red) se traga: se queda el último valor conocido.
	growthbookFile.refreshFeatures({ skipCache: true }).catch(() => {});
};

/**
 * `true` cuando hay que tapar la app con la pantalla de mantenimiento.
 *
 * Además del streaming del SDK (`subscribeToChanges`, que solo funciona si la
 * conexión de GrowthBook lo tiene habilitado), refresca cada 60 s mientras la
 * pestaña está visible y al volver a primer plano, para que prender o apagar el
 * flag llegue en ~1 minuto a quien ya está en el sitio.
 */
export const useMaintenanceMode = (): boolean => {
	const flagOn = useFeatureIsOn(WEB_MAINTENANCE_FLAG);

	useEffect(() => {
		const tick = () => {
			if (document.visibilityState === 'visible') refresh();
		};
		const intervalId = window.setInterval(tick, MAINTENANCE_REFRESH_INTERVAL_MS);
		document.addEventListener('visibilitychange', tick);
		return () => {
			window.clearInterval(intervalId);
			document.removeEventListener('visibilitychange', tick);
		};
	}, []);

	return flagOn && !isMaintenanceBypassed();
};
